import { Link, useParams } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { mediaItems } from "@/mocks/media";
import { newsItems } from "@/mocks/news";
import MediaDetail from "./components/MediaDetail";
import NewsDetail from "./components/NewsDetail";

export default function Detail() {
  const { id } = useParams<{ id: string }>();
  const media = mediaItems.find((item) => item.id === id);
  const news = newsItems.find((item) => item.id === id);

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <div className="pt-16 md:pt-20">
        {media ? (
          <MediaDetail item={media} />
        ) : news ? (
          <NewsDetail item={news} />
        ) : (
          <div className="shell flex min-h-[60vh] flex-col items-center justify-center py-20 text-center">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-2xl text-foreground-400">
              <i className="ri-film-line"></i>
            </span>
            <h1 className="mt-5 font-heading text-2xl font-semibold text-foreground-950">
              内容不存在或已下架
            </h1>
            <p className="mt-2 max-w-md text-sm text-foreground-600">
              你访问的作品或资讯可能已经下架，也可能链接输入有误。可以回到首页或分类页继续浏览。
            </p>
            <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
              <Link
                to="/"
                className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition hover:bg-primary-600"
              >
                返回首页
              </Link>
              <Link
                to="/category/movie"
                className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition hover:border-primary-300 hover:text-primary-600"
              >
                浏览电影库
              </Link>
            </div>
          </div>
        )}
      </div>
      <SiteFooter />
    </div>
  );
}